import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { Button, CardContent } from "@mui/material";
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";

import { Header } from "../../components/layouts";
import { useDeleteKns, useKnses } from "../../lib/hooks";
import { Card, Breadcrumbs, BaseDataGrid } from "../../components/ui";
import { OrgUnit } from "../../lib/types";
import { ConfirmDialog } from "components/common";

const route = "/admin/knses";
const title = "КНС";

const List = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>();
  const { isLoading, data, refetch } = useKnses(page);
  const mutation = useDeleteKns();

  const [deleteId, setDeleteId] = useState<number | null>(null);

  const deleteRecord = () => {
    deleteId &&
      mutation.mutate(deleteId, {
        onSuccess: () => {
          refetch();
        },
      });
  };

  const handleSetDeleteId = (id: number) => {
    setDeleteId(id);
  };

  const handleCancel = () => {
    setDeleteId(null);
  };

  const handleDelete = async () => {
    await deleteRecord();
    handleCancel();
  };

  const columns = [
    {
      field: "name",
      width: 200,
      headerName: "Наименование",
      sortable: false,
    },
    {
      field: "pumpsCount",
      width: 50,
      headerName: "Кол-во насосов",
      sortable: false,
    },
    {
      field: "deviceCode",
      width: 100,
      headerName: "Код устройства",
      sortable: false,
    },
    {
      field: "organizationUnit",
      headerName: "Подразделение",
      sortable: false,
      valueGetter: ({ value: orgUnit }: GridValueGetterParams) => {
        return orgUnit?.name ?? "-";
      },
    },
    {
      field: "location",
      flex: 1,
      headerName: "Адрес",
      sortable: false,
      valueGetter: ({ value: location }: GridValueGetterParams) => {
        return location?.address ?? "-";
      },
    },
    {
      field: "id",
      type: "actions",
      getActions: (params: GridRowParams<OrgUnit>) => {
        return [
          <GridActionsCellItem
            label="Удалить"
            onClick={() => handleSetDeleteId(params.row.id)}
            icon={<DeleteIcon />}
          />,
        ];
      },
    },
  ];

  const hanleChangePage = (page: number) => {
    setPage(page);
  };

  return (
    <>
      <ConfirmDialog
        isLoading={mutation.isLoading}
        open={Boolean(deleteId)}
        onCancel={handleCancel}
        onSubmit={handleDelete}
      />

      <Header
        title={title}
        right={
          <Button onClick={() => navigate(`${route}/new`)}>Создать</Button>
        }
      />
      <Breadcrumbs crumbs={[{ label: "Главная", to: "/" }, { label: title }]} />
      <Card>
        <CardContent>
          <BaseDataGrid
            style={{ height: "calc(100vh - 235px)" }}
            loading={isLoading}
            columns={columns}
            rows={data?.data}
            page={page}
            hanleChangePage={hanleChangePage}
            rowCount={data?.totalCount}
            onRowClick={({ row }: any) => {
              navigate(`${route}/${row.id}/edit`);
            }}
          />
        </CardContent>
      </Card>
    </>
  );
};
export default List;
